/* eslint-disable @typescript-eslint/no-shadow */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { greaseTrapSelectedOptionsAtom } from '../../../services/recoil/atoms/greaseTrapSelectedOptions';
import Title from '../../atoms/Title';
import GreaseTrapServiceForm from '../../forms/GreaseTrapServiceForm';
import StatusBar from '../../molecules/StatusBar';
import Layout from '../Layout';

function GreaseTrapFormWrapper() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectedOptions = useRecoilValue(greaseTrapSelectedOptionsAtom);

  useEffect(() => {
    if (
      selectedOptions &&
      (selectedOptions.location_id === '' ||
        selectedOptions.registered_by === '')
    )
      navigate('/grease-trap-1');
  }, [selectedOptions]);

  return (
    <Layout>
      <>
        <span>
          <Title text={t('grease-trap.title')} />
          <div className="space-y-2">
            <StatusBar
              text={[
                t('grease-trap.step1'),
                t('grease-trap.step2'),
                t('grease-trap.step3'),
              ]}
              active={[false, false, true]}
              done={[true, true, false]}
              justifyStart={true}
            />
          </div>
        </span>
        <GreaseTrapServiceForm />
      </>
    </Layout>
  );
}

export default GreaseTrapFormWrapper;
